import React, { useEffect } from "react";
import { useState } from "react";
import Spinner from "../../../shared/assets/icons/Spinner.jsx";
import {
  AccordionDetails,
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Modal,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  Select,
  DialogActions,
  InputLabel,
  Snackbar,
  Alert,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons";
import CustomInput from "../../../shared/utils/Input";
import moment, { min } from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import Decrypt from "../../../shared/utils/Decrypt";
import { Check, Close, Phone, Search } from "@mui/icons-material";

const ModalToUpdateBatches = ({
  fetchUpdatedBatchDetails,
  openModal,
  batch,
  closeModal,
  setOpenModalToUpdateBatch,
  setAvailableBatches,
  fetchAllJobsBasedOnCampaignId,
  fetchAllBatchesBasedOnCampaignId,
  isPaymentAmount,
  onBatchUpdate,
}) => {
  const [jobDetails, setJobDetails] = React.useState({
    paymentAmount: batch?.jobs[0]?.paymentAmount || isPaymentAmount || "",
    startDate: batch?.jobStartingDate || "",
    endDate: batch?.jobCompletionDate || "",
    batchTitle: batch?.batchTitle || "",
  });
  const [openInstallationPartnerList, setOpenInstallationPartnerList] =
    React.useState(false);
  const [installationPartnerList, setInstallationPartnerList] = React.useState(
    [],
  );
  const [selectedInstallationPartner, setSelectedInstallationPartner] =
    React.useState("");
  const [loading, setLoading] = useState(false);
  const [ipLoading, setIpLoading] = useState(false);

  const serverURL = process.env.REACT_APP_URL;

  // const batch =installationPartnerId?. batch;
  // Snackbar state
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  const tableCellStyle = {
    borderBottom: "1px solid #ddd",
    color: "#36383A",
    fontSize: "14px",
  };

  const handleClose = () => {
    setOpenModalToUpdateBatch(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const saveUpdatedBatches = async () => {
    setLoading(true);
    try {
      if (!batch?._id) {
        throw new Error("No batch selected");
      }

      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${serverURL}/batchOfJobs/updateBatchJob/${batch._id}`,
        {
          jobCompletionDate: jobDetails.endDate,
          jobStartingDate: jobDetails.startDate,
          paymentAmount: jobDetails.paymentAmount,
          batchTitle: jobDetails.batchTitle,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success === true) {
        // Update local state immediately
        setAvailableBatches((prevBatches) =>
          prevBatches.map((b) =>
            b._id === batch._id
              ? {
                  ...b,
                  paymentAmount: jobDetails.paymentAmount,
                  jobStartingDate: jobDetails.startDate,
                  jobCompletionDate: jobDetails.endDate,
                  batchTitle: jobDetails?.batchTitle,
                }
              : b,
          ),
        );

        // Close modal and show success
        handleClose();
        fetchAllJobsBasedOnCampaignId();
        if (typeof fetchUpdatedBatchDetails === "function") {
          fetchUpdatedBatchDetails();
        }

        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          title: "Success!",
          text: "Batch updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // Refresh data after user acknowledges success
          fetchAllJobsBasedOnCampaignId();
        });
      } else {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          title: "Error!",
          text: response.data.message || "Failed to update batch",
          icon: "error",
          confirmButtonText: "OK",
        });
        throw new Error(response?.data?.message || "Failed to update batch");
      }
    } catch (error) {
      console.error("Update batch error:", error);
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        title: "Error!",
        text: error?.response?.data?.message || "Failed to update batch",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setJobDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleIPChangeModalOpen = async () => {
    try {
      setIpLoading(true);
      await fetchAllInstallationPartners();
      setOpenInstallationPartnerList(true);
    } catch (error) {
      console.error("Error fetching partners:", error);
      setSnackbar({
        open: true,
        message: "Failed to load installation partners",
        severity: "error",
      });
    } finally {
      setIpLoading(false);
    }
  };

  const handleIPChangeModalClose = () => {
    setOpenInstallationPartnerList(false);
  };
  const [isSearchIp, setSearchIp] = useState("");
  const [debouncedSearchIp, setDebouncedSearchIp] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchIp(isSearchIp);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [isSearchIp]);

  const fetchAllInstallationPartners = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartner/getAllInstallationPartnersToAssign?nameAndPhoneNumber=${debouncedSearchIp}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 200) {
        setInstallationPartnerList(response.data.data || []);
        // fetchAllJobsBasedOnCampaignId();
      } else {
        throw new Error("Failed to fetch installation partners");
      }
    } catch (error) {
      console.error("Fetch partners error:", error);
      throw error;
    }
  };
  const handleIpSearch = (e) => {
    const { value } = e.target;

    setSearchIp(value);
  };

  useEffect(() => {
    fetchAllInstallationPartners();
  }, [debouncedSearchIp]);

  const saveNewIP = async (installationPartnerId) => {
    setIpLoading(true);
    try {
      if (!batch?._id) {
        throw new Error("No batch selected");
      }

      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${serverURL}/batchOfJobs/updateBatchJob/${batch._id}`,
        { installationPartnerId: installationPartnerId || null }, // Explicitly set to null if undefined
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response?.data?.success) {
        // Update local state with the full IP object if assigning, or null if unassigning
        setAvailableBatches((prevBatches) =>
          prevBatches.map((b) =>
            b._id === batch._id
              ? {
                  ...b,
                  installationPartnerId: installationPartnerId
                    ? installationPartnerList.find(
                        (ip) => ip._id === installationPartnerId,
                      )
                    : null,
                }
              : b,
          ),
        );

        // Also update the local batch object
        const updatedBatch = {
          ...batch,
          installationPartnerId: installationPartnerId
            ? installationPartnerList.find(
                (ip) => ip._id === installationPartnerId,
              )
            : null,
        };

        handleIPChangeModalClose();
        // Show success message
        setSnackbar({
          open: true,
          message: installationPartnerId
            ? "Batch updated successfully"
            : "IP unassigned successfully",
          severity: "success",
        });

        // parent components to update by passing the updated batch
        if (typeof onBatchUpdate === "function") {
          onBatchUpdate(updatedBatch);
        }
        fetchAllBatchesBasedOnCampaignId();

        fetchAllJobsBasedOnCampaignId();
      } else {
        throw new Error(response?.data?.message || "Failed to update IP");
      }
    } catch (error) {
      console.error("Update IP error:", error);
      setSnackbar({
        open: true,
        message: error.message || "Failed to update installation partner",
        severity: "error",
      });
    } finally {
      setIpLoading(false);
      setSearchIp("");
    }
  };

  return (
    <>
      <Modal open={openModal} onClose={closeModal}>
        {/* Background Overlay */}
        {/* <div
        className="fixed inset-0 bg-black bg-opacity-50"
        aria-hidden="true"
      /> */}
        <div className="fixed inset-0 flex items-center justify-center p-4 z-50 overflow-auto">
          <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Sticky Header */}
            <div className="sticky top-0 bg-white z-20 border-b p-6 pb-4">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold">Edit Batch</h2>
                <div onClick={handleClose} className="cursor-pointer">
                  <Cross />
                </div>
              </div>
            </div>

            {/* Scrollable Content Area */}
            <div className="flex-1 overflow-y-auto p-6">
              {batch && (
                <div>
                  <h3 className="text-xl font-bold">{batch.batchTitle}</h3>

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div>
                      <Grid item xs={12} sm={6} md={3}>
                        <CustomInput
                          name="batchTitle"
                          placeholder="Enter Title"
                          title="Batch Title *"
                          size="small"
                          type="text"
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          value={jobDetails?.batchTitle}
                          required
                          className="border-gray-400 focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        sx={{ marginTop: "1rem" }}
                      >
                        <CustomInput
                          name="startDate"
                          placeholder="Enter Start Date"
                          title="Starting Date *"
                          size="small"
                          type="date"
                          onChange={(e) => {
                            const selectedDate = moment(
                              e.target.value,
                              "YYYY-MM-DD",
                            );
                            const today = moment().startOf("day");
                            if (selectedDate.isSameOrAfter(today)) {
                              handleInputChange(e);
                            }
                          }}
                          value={moment(jobDetails.startDate).format(
                            "YYYY-MM-DD",
                          )}
                          min={moment().format("YYYY-MM-DD")}
                          required
                          className="border-gray-400 focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                        />
                      </Grid>
                    </div>

                    <div>
                      <CustomInput
                        name="paymentAmount"
                        placeholder="Enter Amount"
                        title="Pay for Each Job *"
                        size="small"
                        type="number"
                        value={jobDetails.paymentAmount}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (value === "" || /^\d+$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        inputProps={{
                          min: "0",
                          onWheel: (e) => {
                            // Prevent the input value from changing on mouse wheel scroll
                            e.target.blur();
                            e.preventDefault();
                          },
                        }}
                        required
                        className="border-gray-400 focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                      />
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        sx={{ marginTop: "1rem" }}
                      >
                        <Grid item xs={12} sm={6} md={3}>
                          <CustomInput
                            name="endDate"
                            placeholder="Enter Last Date"
                            title="Ending Date *"
                            size="small"
                            type="date"
                            onChange={(e) => {
                              const selectedDate = moment(
                                e.target.value,
                                "YYYY-MM-DD",
                              );
                              const today = moment().startOf("day");
                              if (selectedDate.isSameOrAfter(today)) {
                                handleInputChange(e);
                              }
                            }}
                            value={moment(jobDetails.endDate).format(
                              "YYYY-MM-DD",
                            )}
                            min={moment(jobDetails.startDate).format(
                              "YYYY-MM-DD",
                            )}
                            required
                            className="border-gray-400 focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>

                  <div className="bg-gray-100 p-4 rounded-lg mt-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                      <img
                        src={
                          batch?.installationPartnerId?.profilePhoto ||
                          "/assests/AdminDashboard/userForIP.webp"
                        }
                        alt="IP"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="text-lg font-semibold">
                          {batch?.installationPartnerId?.name ||
                            "No IP Assigned"}
                        </p>
                        <div className="flex items-center text-yellow-500">
                          <span className="ml-1 text-gray-700"></span>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => saveNewIP(null)} // Explicitly pass null to unassign
                          disabled={ipLoading || !batch?.installationPartnerId}
                          className="text-red-500 border border-red-500 px-3 py-1 rounded-lg hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Unassign IP
                        </button>
                        <button
                          onClick={handleIPChangeModalOpen}
                          className="text-blue-500 border border-blue-500 px-3 py-1 rounded-lg hover:bg-blue-50"
                        >
                          Change IP
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* IP Selection Dialog */}
                  <Dialog
                    open={openInstallationPartnerList}
                    onClose={handleIPChangeModalClose}
                    fullWidth
                    maxWidth="sm"
                    PaperProps={{
                      sx: {
                        borderRadius: "18px",
                        overflow: "hidden",
                        boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",
                        m: 2,
                      },
                    }}
                  >
                    {/* Header */}
                    <DialogTitle
                      sx={{
                        px: 3,
                        py: 2.2,
                        borderBottom: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-[17px] font-semibold text-slate-800">
                            Select Installation Partner
                          </h2>
                        </div>

                        {/* Close button */}
                        <button
                          type="button"
                          onClick={handleIPChangeModalClose}
                          className="
          flex h-8 w-8 items-center justify-center
          rounded-full
          text-slate-400
          transition-all
          hover:bg-slate-100
          hover:text-slate-700
        "
                        >
                          <Close fontSize="small" />
                        </button>
                      </div>
                    </DialogTitle>

                    {/* Content */}
                    <DialogContent
                      sx={{
                        px: 3,
                        py: 2.5,
                        backgroundColor: "#f8fafc",
                      }}
                    >
                      <div className="flex flex-col gap-4">
                        {/* Search */}
                        <div className="relative mt-2">
                          <Search
                            sx={{
                              position: "absolute",
                              left: "13px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#94a3b8",
                              fontSize: 20,
                              zIndex: 1,
                            }}
                          />

                          <input
                            type="search"
                            placeholder="Search by name or phone number..."
                            value={isSearchIp}
                            onChange={(e) => setSearchIp(e.target.value)}
                            className="
            h-11
            w-full
            rounded-xl
            border border-slate-200
            bg-white
            pl-11 pr-4
            text-[13px]
            text-slate-700
            outline-none
            placeholder:text-slate-400
            transition-all
            focus:border-[#1976d2]
            focus:ring-4
            focus:ring-blue-500/10
          "
                          />

                          {isSearchIp && (
                            <button
                              type="button"
                              onClick={() => setSearchIp("")}
                              className="
              absolute right-3 top-1/2
              -translate-y-1/2
              text-slate-400
              hover:text-slate-600
            "
                            >
                              {/* <Close sx={{ fontSize: 17 }} /> */}
                            </button>
                          )}
                        </div>

                        {/* Partner List */}
                        <div
                          className="
          max-h-[300px]
          overflow-y-auto
          pr-1
          space-y-2
          scrollbar-thin
        "
                        >
                          {installationPartnerList
                            ?.filter((partner) =>
                              `${partner?.name || ""} ${partner?.phoneNumber || ""}`
                                .toLowerCase()
                                .includes(isSearchIp.toLowerCase()),
                            )
                            .map((partner) => {
                              const isSelected =
                                selectedInstallationPartner === partner?._id;

                              return (
                                <div
                                  key={partner._id}
                                  onClick={() => {
                                    setSelectedInstallationPartner(
                                      partner?._id,
                                    );
                                  }}
                                  className={`
                  group
                  flex items-center justify-between
                  rounded-xl
                  border
                  p-3.5
                  cursor-pointer
                  transition-all duration-200
                  ${
                    isSelected
                      ? "border-blue-400 bg-blue-50/70 shadow-sm"
                      : "border-slate-200 bg-white hover:border-blue-200 hover:bg-slate-50 hover:shadow-sm"
                  }
                `}
                                >
                                  <div className="flex items-center gap-3">
                                    {/* Avatar */}
                                    <div
                                      className={`
                      flex
                      h-10 w-10
                      shrink-0
                      items-center justify-center
                      rounded-full
                      text-sm
                      font-semibold
                      ${
                        isSelected
                          ? "bg-[#1976d2] text-white"
                          : "bg-slate-100 text-slate-600"
                      }
                    `}
                                    >
                                      {partner?.name
                                        ?.charAt(0)
                                        ?.toUpperCase() || "I"}
                                    </div>

                                    {/* Details */}
                                    <div className="flex flex-col gap-1">
                                      <span
                                        className={`
                        text-[13px]
                        font-semibold
                        ${isSelected ? "text-[#1565c0]" : "text-slate-700"}
                      `}
                                      >
                                        {partner.name}
                                      </span>

                                      <div className="flex items-center gap-1.5">
                                        <Phone
                                          sx={{
                                            fontSize: 14,
                                            color: "#94a3b8",
                                          }}
                                        />

                                        <span className="text-[11px] text-slate-500">
                                          {partner.phoneNumber ||
                                            "No phone number"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Selected Check */}
                                  <div
                                    className={`
                    flex
                    h-7 w-7
                    items-center justify-center
                    rounded-full
                    transition-all
                    ${
                      isSelected
                        ? "bg-[#1976d2] text-white"
                        : "bg-slate-100 text-transparent group-hover:bg-slate-200"
                    }
                  `}
                                  >
                                    <Check sx={{ fontSize: 17 }} />
                                  </div>
                                </div>
                              );
                            })}

                          {/* Empty State */}
                          {installationPartnerList?.filter((partner) =>
                            `${partner.name || ""} ${partner.phoneNumber || ""}`
                              .toLowerCase()
                              .includes(isSearchIp.toLowerCase()),
                          ).length === 0 && (
                            <div
                              className="
            flex
            min-h-[180px]
            flex-col
            items-center
            justify-center
            rounded-xl
            border border-dashed border-slate-300
            bg-white
          "
                            >
                              <div
                                className="
              mb-3
              flex h-12 w-12
              items-center justify-center
              rounded-full
              bg-slate-100
            "
                              >
                                <Search
                                  sx={{
                                    color: "#94a3b8",
                                    fontSize: 23,
                                  }}
                                />
                              </div>

                              <p className="text-[13px] font-semibold text-slate-600">
                                {`No installation partner found`}
                              </p>

                              <p className="mt-1 text-[11px] text-slate-400">
                                <p className="mt-1 text-[11px] text-slate-400">
                                  {`Try searching with a different name or phone number`}
                                </p>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </DialogContent>

                    {/* Footer */}
                    <DialogActions
                      sx={{
                        px: 3,
                        py: 2,
                        borderTop: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Selected info */}
                      <div className="hidden sm:block">
                        {selectedInstallationPartner ? (
                          <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-green-500" />

                            <span className="text-[11px] text-slate-500">
                              {`Partner selected`}
                            </span>
                          </div>
                        ) : (
                          <span className="text-[11px] text-slate-400">
                            {`No partner selected`}
                          </span>
                        )}
                      </div>

                      <div className="flex items-center gap-2">
                        {/* Cancel */}
                        <Button
                          onClick={handleIPChangeModalClose}
                          disabled={ipLoading}
                          sx={{
                            textTransform: "none",
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#64748b",
                            borderRadius: "10px",
                            px: 2,
                            py: 0.9,

                            "&:hover": {
                              backgroundColor: "#f1f5f9",
                            },
                          }}
                        >
                          Cancel
                        </Button>

                        {/* Save */}
                        <Button
                          onClick={async () => {
                            await saveNewIP(selectedInstallationPartner);
                            handleIPChangeModalClose();
                          }}
                          disabled={!selectedInstallationPartner || ipLoading}
                          variant="contained"
                          startIcon={
                            ipLoading ? (
                              <Spinner />
                            ) : (
                              <Check sx={{ fontSize: 18 }} />
                            )
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: "13px",
                            fontWeight: 600,
                            borderRadius: "10px",
                            px: 2.2,
                            py: 1,

                            background:
                              "linear-gradient(135deg, #1976d2, #1565c0)",

                            boxShadow: "0 5px 14px rgba(25, 118, 210, 0.22)",

                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #1565c0, #0d47a1)",

                              boxShadow: "0 7px 18px rgba(25, 118, 210, 0.30)",

                              transform: "translateY(-1px)",
                            },

                            "&:active": {
                              transform: "translateY(0)",
                            },

                            "&.Mui-disabled": {
                              background: "#e2e8f0",
                              color: "#94a3b8",
                              boxShadow: "none",
                            },

                            transition: "all 0.2s ease",
                          }}
                        >
                          {ipLoading ? "Saving..." : "Save & Exit"}
                        </Button>
                      </div>
                    </DialogActions>
                  </Dialog>
                  {/* Job Table */}
                  <AccordionDetails>
                    <Box sx={{ overflow: "auto", maxHeight: "16rem" }}>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                              <TableCell sx={tableCellStyle}>City</TableCell>
                              <TableCell sx={tableCellStyle}>Address</TableCell>
                              <TableCell sx={tableCellStyle}>
                                Store Manager
                              </TableCell>
                              <TableCell sx={tableCellStyle}>Job Pay</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {batch?.jobs?.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell sx={tableCellStyle}>
                                  {row.city}
                                </TableCell>
                                <TableCell sx={tableCellStyle}>
                                  <LocationAddressComponent
                                    storeName={row.storeName}
                                    address={row.address}
                                    city={row.city}
                                    state={row.state}
                                    zipCode={row.zipCode}
                                  />
                                </TableCell>
                                <TableCell sx={tableCellStyle}>
                                  <StoreManagerDetailsComponent
                                    storeOwnerName={row.storeOwnerName}
                                    storeOwnerPhoneNumber={
                                      row.storeOwnerPhoneNumber
                                    }
                                  />
                                </TableCell>
                                <TableCell sx={tableCellStyle}>
                                  ₹{row.paymentAmount}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </div>
              )}
            </div>

            {/* Sticky Footer */}
            <div className="sticky bottom-0 bg-white z-20 border-t p-4">
              <div className="flex justify-end">
                <button
                  className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center min-w-[150px]"
                  disabled={
                    !jobDetails.paymentAmount ||
                    !jobDetails.startDate ||
                    !jobDetails.endDate ||
                    isNaN(jobDetails.paymentAmount) ||
                    loading
                  }
                  onClick={saveUpdatedBatches}
                >
                  {loading ? (
                    <>
                      <Spinner />
                      Updating...
                    </>
                  ) : (
                    "Update Changes"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "right", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          autoHideDuration={5000}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

const LocationAddressComponent = ({
  storeName,
  address,
  city,
  state,
  zipCode,
}) => {
  return (
    <div className="flex flex-col">
      <span className="font-medium">{storeName}</span>
      <span className="text-sm">{`${address}, ${city}, ${state}-${zipCode}`}</span>
    </div>
  );
};
const StoreManagerDetailsComponent = ({
  storeOwnerName,
  storeOwnerPhoneNumber,
}) => {
  return (
    <div className="flex flex-col">
      <span className="font-medium">{storeOwnerName}</span>
      <span className="text-sm">{storeOwnerPhoneNumber}</span>
    </div>
  );
};

export default ModalToUpdateBatches;
